import { render } from "./DimensionForm.vue?vue&type=template&id=b2baea22&scoped=true"
import script from "./DimensionForm.vue?vue&type=script&lang=js"
export * from "./DimensionForm.vue?vue&type=script&lang=js"

import "./DimensionForm.vue?vue&type=style&index=0&id=b2baea22&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2baea22"]])

export default __exports__